<template>
    <v-dialog v-model="dialog" width=50%>
        <v-card>
            <v-card-title class="px-8">
                Composition of the review average<br><br>
            </v-card-title>
            <v-row no-gutters class="row-default">
                <v-col cols="12" class="px-8">
                    <table id="test" style="width:100%">
                        <tr class="first-row">
                            <th></th>
                            <th>Reviews as<br>listed on</th>
                            <th class="numreviews">Number of<br>reviews</th>
                            <th class="numreviews">Average<br>score</th>
                            <th class="numreviews">Published<br>reviews</th>
                            <th class="numreviews">Published<br>average</th>                            
                        </tr>
                        <tr>
                            <td class="logo-row"><img src="@/assets/vfy.png" alt="" height=30 /></td>
                            <td>Villa for You</td>
                            <td class="numreviews">{{ this.review_details.total_vfy_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_vfy_reviews_average }}</td>
                            <td class="numreviews">{{ this.review_details.total_vfy_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_vfy_reviews_average_pub }}</td>                            
                        </tr>
                        <tr>
                            <td class="logo-row"><img src="@/assets/airbnb.png" alt="" height=30 /></td>
                            <td>Airbnb</td>
                            <td class="numreviews">{{ this.review_details.total_airbnb_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_airbnb_average_score }}</td>
                            <td class="numreviews">{{ this.review_details.total_airbnb_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_airbnb_average_score_pub }}</td>
                        </tr>                        
                        <tr>
                            <td class="logo-row"><img src="@/assets/booking.png" alt="" height=30 /></td>
                            <td>Booking.com</td>
                            <td class="numreviews">{{ this.review_details.total_booking_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_booking_average_score }}</td>
                            <td class="numreviews">{{ this.review_details.total_booking_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_booking_average_score_pub }}</td>                            
                        </tr>
                        <tr>
                            <td class="logo-row"><img src="@/assets/vrbo.png" alt="" height=30 /></td>
                            <td>Vrbo</td>
                            <td class="numreviews">{{ this.review_details.total_vrbo_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_vrbo_average_score }}</td>
                            <td class="numreviews">{{ this.review_details.total_vrbo_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_vrbo_average_score_pub }}</td>                            
                        </tr>
                        <tr>
                            <td class="logo-row"><img src="@/assets/holidu.png" alt="" height=30 /></td>
                            <td>Holidu</td>
                            <td class="numreviews">{{ this.review_details.total_holidu_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_holidu_average_score }}</td>
                            <td class="numreviews">{{ this.review_details.total_holidu_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_holidu_average_score_pub }}</td>                            
                        </tr>
                        <tr class="final-row">
                            <td></td>
                            <td>Total</td>
                            <td class="numreviews">{{ this.review_details.total_reviews }}</td>
                            <td class="numreviews">{{ this.review_details.total_average_score }}</td>
                            <td class="numreviews">{{ this.review_details.total_reviews_pub }}</td>
                            <td class="numreviews">{{ this.review_details.total_average_score_pub }}</td>
                        </tr>                        
                    </table>
                    <span class="br_medium"></span>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>



<script>

export default {
    components: {
    },
    data () {
        return {
            dialog: false,
            review_details: {},
        }
    },
    methods: {
        open(reviews) {
            this.review_details = reviews;
            this.loading = false;
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
    },
}
</script>

<style scoped>
    table,
    th,
    td {
        border: 1px solid lightblue;
        border-collapse: collapse;
        padding-left: 15px;
        padding-top: 2px;
        padding-bottom: 2px;
        text-align:left;
        border-left: hidden;
        border-right: hidden;    
    }
    .numreviews {
        padding-left: 15px;
        padding-right: 50px;
        padding-top: 2px;
        padding-bottom: 2px;
        text-align:right;
    }
    .final-row{
        border-top: 4px solid lightblue;
        border-collapse: collapse;
        padding-left: 15px;
        padding-top: 3px;
        padding-bottom: 3px;
        font-weight: bold;
        border-bottom: hidden;
    }
    .first-row{
    border-top: hidden;   
    }
    .logo-row{
        padding-left: 0px;
        padding-top: 5px;
        padding-bottom: 0px;
        padding-right: 5px;
        text-align:center;
        border-top: hidden;
        border-bottom: hidden;
    }
    .row-default {
        cursor: default;
    }
    .br_medium {
        display: block;
        margin-bottom: 1em;
    }
</style>